// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Lightbox-Backdrop-module--cls1--1YaUO","cls2":"Lightbox-Backdrop-module--cls2--3mUqH Lightbox-Backdrop-module--cls1--1YaUO"};